import React from 'react';
import { debounce, isEqual } from 'lodash';
import {
  Button, Col, Dropdown, Input, Layout, Menu,
  Modal, Row, Select, Form, Checkbox, Card, Space, notification,
  Upload
} from 'antd';
import {
  DownOutlined, LogoutOutlined, UserOutlined, SwapOutlined,
  LockOutlined, QuestionCircleTwoTone, NotificationOutlined
} from '@ant-design/icons';
import BaseComponent from 'base/BaseComponent';
import { enhance } from 'base/BaseEnhance';
import SessionService from 'service/SessionService';
import NoticeHistoryModal from './noticeHistoryModal/NoticeHistoryModal';
import Main from '../main/Main';
import Constants from 'constants/Constants';
import './PageHeader.less';

const { Header } = Layout;
const { Option } = Select;

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 }
};

/**
 * 主页头部显示区域
 */
class PageHeader extends BaseComponent {
  passwordChangeFormRef = React.createRef();
  oldPassword = null;
  newPassword = null;
  confirmPassword = null;

  constructor(props) {
    super(props);

    this.state = {
      changeUserModalVisible: false,
      proxyUserList: [],
      proxyUserId: null,
      changePasswordModalVisible: false,
      noticeActiveModalVisible: false,
      noticeActiveList: [],
      apiNoticeActiveList: [],
      supplierName: null,
      todoList: [],
      todoCount: 0,
      hospitalChangeModalVisible: false,
      hospitalId: null,
      hospitalName: null,
      hospitalList: [],
      expiredPasswordModifyForceFlag: false
    };

    this.changeUserInputChange = debounce(this.changeUserInputChange, 500);

    // 获取供应商名称
    super.sendGetRequest('/plat-delivery/userSupplier/getUserSupplierName',
      (result) => {
        if (result != null) {
          this.setState({
            supplierName: result
          });
        }
      }, (error) => {
        // 获取供应商失败时，返回登录
        super.showMessage(error);
        this.logout();
      });
  }

  componentDidMount() {
    this.getProxyUserList();
    this.showModalByOrder(0);
    this.getNoticeProfileInfo();
    this.getExpirdPasswordForceProfileInfo();
  }

  addTabMain = () => {
    const { hospitalChangeModalVisible } = this.state;
    if (!hospitalChangeModalVisible) {
      this.showModalByOrder(2);
    }

    this.addTab('首页', Main, '/main', false);
  }

  // 顺序显示弹出框（弹窗顺序：修改密码 = 0、变更医院 = 1、公告弹框 = 2）
  showModalByOrder = (modalOrder) => {
    // 检查是否显示修改密码弹出框
    if (modalOrder === 0) {
      this.checkShowChangePasswordModal();
    }

    // 获取用户医院列表
    if (modalOrder === 1) {
      this.getUserHispitalData();
    }

    // 获取公告信息
    if (modalOrder === 2) {
      if (!SessionService.noticeShowFlag) {
        if (SessionService.systemType !== Constants.SYSTEM_TYPE_SYS) {
          this.getNoticeActiveData();
        }
      }
    }
  }

  checkShowChangePasswordModal = () => {
    const param = this.props.location.state;
    if (param && param.resetPassword) {
      super.showMessage('密码过期，请修改');
      this.setState({
        changePasswordModalVisible: true
      });
    } else {
      this.showModalByOrder(1);
    }
  }

  getNoticeActiveData = () => {
    this.sendPostRequest('/system/notice/getNoticeActiveList', null, (result) => {
      if (result != null && result.length > 0) {
        // 获取需要处理的API公告列表
        var apiNoticeActiveList = [];
        result.forEach(notice => {
          const fileList = [];
          if (notice.filePath && notice.filePath.length > 0) {
            const fileStrList = notice.filePath.split(',');
            fileStrList.forEach((item, i) => {
              const filePath = item;
              fileList.push({
                uid: i,
                key: filePath,
                url: '/image' + filePath,
                name: filePath.substring(filePath.lastIndexOf('/') + 1),
                hosFilePath: filePath
              });
            });
          }
          notice.fileList = fileList;
          if (notice.noticeType === 1) {
            apiNoticeActiveList.push(notice);
          }
        });
        this.setState({
          noticeActiveList: result || [],
          noticeActiveModalVisible: true,
          apiNoticeActiveList
        });
        SessionService.noticeShowFlag = 1;
      }
    });
  }

  getUserHispitalData = () => {
    super.sendGetRequest('/plat-delivery/userHospital/getUserHospitalList', (result) => {
      const hospitalList = result || [];
      this.setState({
        hospitalList
      });

      if (hospitalList.length === 0) {
        this.addTabMain();
        this.props.getUserMenuList();
      }

      if (hospitalList.length > 0) {
        // 获取当前绑定的医院ID，如果没有弹出选择。
        super.sendGetRequest('/plat-delivery/userHospital/getUserSelectedHospital', (result) => {
          if (result != null) {
            this.setState({
              hospitalId: result.key,
              hospitalName: result.value
            });
            this.getHospitalModuleVersionGroupList();
            this.getWatermarkFlag();
            this.props.getTodoList();
          } else {
            // hospitalList只有一个，自动切换医院
            if (hospitalList.length === 1) {
              this.setState({
                hospitalId: hospitalList[0].key,
                hospitalName: hospitalList[0].value
              });
              super.sendPostRequest('/plat-delivery/userHospital/changeSelectedHospital', { id: hospitalList[0].key }, () => {
                super.showMessage('切换医院成功', 'success');
                this.getWatermarkFlag();
                this.getHospitalModuleVersionGroupList();
                this.props.getTodoList();
                SessionService.noticeShowFlag = 0;
              });
            } else {
              // hospitalList超过一个，弹出框手动切换医院
              this.setState({
                hospitalId: null,
                hospitalName: null
              });
              this.setState({
                hospitalChangeModalVisible: true
              });
            }
          }
          this.addTabMain();
        }, (errorMessage) => {
          this.addTabMain();
          this.showMessage(errorMessage);
        });
      }
    }, (errorMessage) => {
      this.addTabMain();
      this.getHospitalModuleVersionGroupList();
      this.showMessage(errorMessage);
    });
  }

  // 获取角色代理列表
  getProxyUserList(searchValue) {
    super.sendPostRequest('/system/proxy/getProxyUserList', { searchValueLike: searchValue },
      (response) => {
        var proxyUserList = null;
        if (response == null) {
          proxyUserList = [];
        } else {
          proxyUserList = response;
        }
        this.setState({
          proxyUserList: proxyUserList
        });
      });
  }

  // 医院菜单
  hospitalMenu = () => (
    <Menu onClick={this.hospitalMenuClick}>
      {this.state.hospitalList.map(value => {
        return (
          <Menu.Item key={value.key}>{value.value}</Menu.Item>
        );
      })}
    </Menu>
  );

  hospitalMenuClick = ({ key }) => {
    if (key !== this.state.hospitalId) {
      this.changeHospital(key);
    }
  }

  // 获取是否展示水印标识
  getWatermarkFlag = () => {
    // 移除水印base64缓存
    sessionStorage.removeItem('url');
    sessionStorage.removeItem('watermark');
    this.sendPostRequest('/remote-system/remote/getProfileValueByCode', { code: 'HMM_REPORT_WATERMARK_ADD_FLAG' }, (result) => {
      sessionStorage.setItem('watermark', result && result.toLowerCase() === 'yes' ? 1 : 0);
    }, () => {
      console.warn('HMM_REPORT_WATERMARK_ADD_FLAG failed!');
    });
  }

  changeHospital = (hospitalId) => {
    const that = this;
    super.sendPostRequest('/plat-delivery/userHospital/changeSelectedHospital', { id: hospitalId }, () => {
      super.showMessage('切换医院成功', 'success');
      SessionService.noticeShowFlag = 0;
      window.location.reload();
      window.onload = function() {
        that.getHospitalModuleVersionGroupList();
        this.getWatermarkFlag();
      };
    });
  }

  // 获取院内模块版本
  getHospitalModuleVersionGroupList = () => {
    this.removeAllVersion();
    this.sendPostRequest('/remote-system/remote/getModuleVersionGroup', {}, result => {
      this.props.getUserMenuList && this.props.getUserMenuList();
      if (result != null && result.length > 0) {
        result.forEach(info => {
          if (info.version && info.version.includes('_4.0')) {
            info.version = info.version.replace('_4.0', '');
          }
          localStorage.setItem('hospital_version_' + info.moduleName, info.version);
        });
        this.getProfileValueByCodepriceEnter();
        const versionFlagFive = +localStorage.getItem(Constants.HOSPITAL_MODULE_HMM_BACK) >= 2504;
        if (versionFlagFive) {
          this.getAmountAndPriceZero();
          this.getProfileValueByCodeAmountAndPricePoint();
        } else {
          this.getPriceZero();
          this.getAmountZero();
          this.getProfileValueByCodeAmountPoint();
          this.getProfileValueByPricePoint();
      }
      }
    }, (err) => {
      this.onFail(err);
      this.props.getUserMenuList && this.props.getUserMenuList();
    });
  };

  onFail = (err) => {
    console.log(err);
  }

  // 移除院内版本
  removeAllVersion = () => {
    localStorage.removeItem(Constants.HOSPITAL_MODULE_HMM_BACK);
    localStorage.removeItem(Constants.HOSPITAL_MODULE_HMM_ADMIN);
    localStorage.removeItem(Constants.HOSPITAL_MODULE_HMM_SHELVES);
    localStorage.removeItem(Constants.HOSPITAL_MODULE_HMM_CABINET);
    localStorage.removeItem(Constants.HOSPITAL_MODULE_HMM_TRACK);
    localStorage.removeItem(Constants.HOSPITAL_MODULE_HMM_BIGSCREEN);
    localStorage.removeItem(Constants.HOSPITAL_MODULE_HMM_BI);
  }

  showHospitalChangeModal = () => {
    this.setState({
      hospitalChangeModalVisible: true
    });
  }

  hideHospitalChangeModal = () => {
    this.setState({
      hospitalChangeModalVisible: false
    });
  }

  userMenuClick = ({ key }) => {
    switch (key) {
      case 'changePassword':
        this.showChangePasswrodModal();
        break;
      case 'changeUser':
        this.showChangeUserModal();
        break;
      case 'showNoticeHistory':
        this.showNoticeHistoryModal();
        break;
      case 'logout':
        this.logout();
        break;
      default:
        break;
    }
  };

        // 院内单价录入长度限制
        getProfileValueByCodepriceEnter = () => {
          super.sendPostRequest('/remote-system/remote/getProfileValueByCode', { code: 'HMM_DEFAULT_PRICE_POINT_ENTER' }, (result) => {
            if (result === null || result > 4) {
              localStorage.setItem('priceEnter', 4);
            } else {
              localStorage.setItem('priceEnter', result);
            }
          });
        }

          // 院内单价金额是否补零
          getAmountAndPriceZero = () => {
            super.sendPostRequest('/remote-system/remote/getProfileValueByCode', { code: 'HMM_NUMBER_ZERO_FILL_FLAG' }, (result) => {
              if (result === null) {
                localStorage.setItem('amountZero', 'YES');
                localStorage.setItem('priceZero', 'YES');
              } else {
                const resultMap = new Map(Object.entries(JSON.parse(result)));
                localStorage.setItem('amountZero', resultMap.get('amount') || 'YES');
                localStorage.setItem('priceZero', resultMap.get('price') || 'YES');
              }
            });
          }

          // 院内单价金额默认长度
          getProfileValueByCodeAmountAndPricePoint = () => {
            super.sendPostRequest('/remote-system/remote/getProfileValueByCode', { code: 'HMM_DEFAULT_NUMBER_POINT_LENGTH' }, (result) => {
              if (result === null) {
                localStorage.setItem('amountPoint', 2);
                localStorage.setItem('pricePoint', 3);
              } else {
                const resultMap = new Map(Object.entries(JSON.parse(result)));
                localStorage.setItem('amountPoint', resultMap.get('amount') || 2);
                localStorage.setItem('pricePoint', resultMap.get('price') || 3);
              }
            });
          }

  // 价格是否补0
  getPriceZero=() => {
    super.sendPostRequest('/system/common/getProfileValueByCode', { code: 'HMM_PRICE_ZERO_FILL_FLAG' }, (result) => {
      localStorage.setItem('priceZero', result);
    });
  }

   // 金额是否补0
   getAmountZero=() => {
     super.sendPostRequest('/system/common/getProfileValueByCode', { code: 'HMM_AMOUNT_ZERO_FILL_FLAG' }, (result) => {
       localStorage.setItem('amountZero', result);
     });
   }

  // 平台金额默认小数长度
  getProfileValueByCodeAmountPoint = () => {
    super.sendPostRequest('/system/common/getProfileValueByCode', { code: 'HMM_DEFAULT_AMOUNT_POINT' }, (result) => {
      if (result === null) {
        localStorage.setItem('amountPoint', 2);
      } else {
        localStorage.setItem('amountPoint', result);
      }
    });
  }

  // 单价默认小数点长度
  getProfileValueByPricePoint = () => {
    super.sendPostRequest('/system/common/getProfileValueByCode', { code: 'HMM_DEFAULT_PRICE_POINT' }, (result) => {
      if (result === null) {
        localStorage.setItem('pricePoint', 3);
      } else {
        localStorage.setItem('pricePoint', result);
      }
    });
  }

  userMenu = (
    <Menu onClick={this.userMenuClick}>
      <Menu.Item key="changeUser"><SwapOutlined />切换用户</Menu.Item>
      {
        SessionService.systemType !== 0 ? (
          <Menu.Item key="showNoticeHistory"><NotificationOutlined />查看历史公告</Menu.Item>
        ) : ''
      }
      <Menu.Item key="changePassword"><LockOutlined />修改密码</Menu.Item>
      <Menu.Item key="logout"><LogoutOutlined />注销</Menu.Item>
    </Menu>
  );

  // ----------- 修改密码相关处理 start ------------
  showChangePasswrodModal() {
    this.setState({
      changePasswordModalVisible: true
    });
  }

  hideChangePasswordModal = () => {
    if (this.state.expiredPasswordModifyForceFlag) {
      this.logout();
    } else {
      this.setState({
        changePasswordModalVisible: false
      }, () => this.showModalByOrder(1));
    }
  }

  confirmChangePassword = () => {
    this.passwordChangeFormRef.current.validateFields().then(values => {
      if (values.confirmPassword !== values.newPassword) {
        super.showMessage('新密码与确认密码不一致，请重新输入');
        return;
      }

      super.sendPostRequest('/system/password/modifyPassword', values, () => {
        super.showMessage('密码修改成功，请重新登录', 'success');
        this.logout();
      });
    }).catch(errorInfo => {
    });
  }

  // 过期密码是否强制修改
  getExpirdPasswordForceProfileInfo = () => {
    this.sendPostRequest('/system/common/getProfileValueByCode', { code: 'SYS_EXPIRED_PASSWORD_MODIFY_FORCE_FLAG' }, (result) => {
      if (result !== null && result !== undefined) {
        this.setState({
          expiredPasswordModifyForceFlag: isEqual('YES', result.toUpperCase())
        });
      }
    });
  }
  // ----------- 修改密码相关处理 end --------------

  // ----------- 切换用户相关处理 start ------------
  showChangeUserModal = () => {
    this.setState({
      changeUserModalVisible: true
    });
  }

  hideChangeUserModal = () => {
    this.setState({
      changeUserModalVisible: false
    });
  }

  changeUserInputChange = value => {
    this.getProxyUserList(value);
  }

  changeUserSelectChange = value => {
    // 选择删除时，重新获取全部数据
    if (value == null) {
      this.getProxyUserList();
    }
    this.setState({
      proxyUserId: value
    });
  }

  changeProxyUser = () => {
    if (this.state.proxyUserId == null) {
      super.showMessage('请选择代理用户');
    } else {
      super.sendPostRequest('/changeProxyUser', { id: this.state.proxyUserId },
        (result) => {
          this.setState({
            changeUserModalVisible: false
          });

          SessionService.userName = result.userName;
          SessionService.localUserName = result.userName;
          SessionService.proxyUserName = result.proxyUserName;
          SessionService.systemType = result.systemType;
          window.location.reload();
        });
    }
  }
  // ----------- 切换用户相关处理 end ------------

  // ----------- 有效公告相关处理 start ------------

  // 查看历史公告
  showNoticeHistoryModal = () => {
    this.noticeHistoryRef && this.noticeHistoryRef.showNoticeHistoryData();
  }

  // 有效公告弹出框展示
  showNoticeActiveModal = () => {
    this.setState({
      noticeActiveModalVisible: true
    });
  }

  // 有效公告弹出框取消展示
  handleNoticeActiveModal = () => {
    const { noticeActiveList } = this.state;

    const params = [];
    noticeActiveList.forEach(notice => params.push({ noticeId: notice.id, activeStatus: notice.activeStatus }));

    super.sendPostRequest('/system/notice/updateNoticeActiveInfo', params, () => {
      this.setState({
        noticeActiveModalVisible: false
      });
    });
  }

  // 更改“下次不再显示”是否勾选
  onCheckboxChange = (noticeId, checked) => {
    const { noticeActiveList } = this.state;
    // 更新公告有效状态
    const targetValue = noticeActiveList.find(value => isEqual(value.id, noticeId));
    targetValue.activeStatus = checked ? 0 : 1;
    this.setState({
      noticeActiveList
    });
  }

  // 去处理API公告，跳转到相关页面
  handleNoticeClick = (apiNoticeActiveList) => {
    this.handleNoticeActiveModal();
    apiNoticeActiveList.forEach(notice => {
      super.addTabByUrl(notice.noticeName, notice.noticeUrl, notice.noticeUrl + '?' + notice.parameter, true, notice.parameter);
    });
  }

  // 系统公告刷新间隔时间（秒）
  getNoticeProfileInfo = () => {
    this.sendPostRequest('/system/common/getProfileValueByCode', { code: 'SYS_NOTICE_INTERVAL_SECONDS' }, (result) => {
      if (result !== null) {
        const intervalTime = Number(result) * 1000 || 3600000;
        this.noticeFetchInterval = setInterval(this.getNoticeActiveData, intervalTime);
      }
    });
  }

  // ----------- 有效公告相关处理 end --------------
  helpAi=() => {
    const notificationElementAi = document.getElementsByClassName('notifcationAi');
    if (notificationElementAi.length === 1) {
      // notification.destroy();
      return;
    }
    notification.destroy();
    this.sendPostRequest('/system/ai/getAiSafeConfigInfo', {}, (result) => {
      const regex = /172\.16\./;
      let url = '';
      if (!result.aiInUrl) {
        url = result.aiUrl;
      } else {
        if (regex.test(window.location.href)) {
          url = result.aiUrl;
        } else {
          url = result.aiInUrl;
        }
      }
      const configAi = {
        message: 'AI客服',
        placement: 'bottomRight',
        bottom: 45,
        duration: null,
        className: 'affix-notification notifcationAi',
        style: {
          marginBottom: 0,
          marginRight: -15,
          backgroundImage: 'linear-gradient(to bottom right, #0876D5, #00B7D7)',
          padding: '10px 10px'
        },
        description: (
          <iframe
            id='aiIframe'
            src={url}
            style={{ width: '100%', height: '500px', border: 'none', backgroundColor: '#fff' }}
            frameBorder="0"
            allow="microphone"
          />
        )
      };
      notification.open(configAi);
      // 使用 setTimeout 稍微延迟一下，确保 iframe 有机会被添加到 DOM 中
      setTimeout(() => {
        const iframe = document.getElementById('aiIframe');
        if (iframe) {
          const data = {
            username: result.userName,
            token: result.token,
            source: result.source
          };
          iframe.onload = () => {
            iframe.contentWindow.postMessage(data, url);
          };
          iframe.contentWindow.postMessage(data, url);
        } else {
          console.error('未找到 iframe 元素');
        }
      }, 200);
    });
  }

  logout() {
    // 通知服务端系统登出
    super.sendPostRequest('/logout', {});
    // 清空sessionStorage数据
    SessionService.clear();
    // 跳转到登录页面
    super.jumpToLogin();
  }

  render() {
    const { proxyUserList, noticeActiveList, noticeActiveModalVisible, apiNoticeActiveList } = this.state;

    const currentHospitalName = this.state.hospitalId == null ? '未选择医院' : this.state.hospitalName;
    return (
      <Header className="fh-dashboard-header" style={{ position: 'fixed', top: '0px', width: '100%' }}>
        <div className="fh-dashboard-header-item">
          <div className="fh-dashboard-header-left">全程可追溯智慧医疗供应链</div>
          <div className={this.props.isCollapsed ? 'fh-dashboard-header-right' : 'fh-dashboard-header-right-open'}>
            {
              this.state.hospitalList.length === 1
                ? (<span className='fh-hospital-span'>
                  {currentHospitalName}
                </span>)
                : (
                  <Dropdown overlay={this.hospitalMenu}>
                    <Button type="link" style={{ color: '#FFF' }}>
                      {currentHospitalName}<DownOutlined />
                    </Button>
                  </Dropdown>)
            }
            {
              this.state.supplierName ? <span className='fh-supplier-span'>
                {this.state.supplierName}
              </span> : ''
            }
            <Dropdown overlay={this.userMenu}>
              <Button type="link" style={{ color: '#FFF' }}>
                <UserOutlined />
                {SessionService.userName}
                {SessionService.proxyUserName ? ('(' + SessionService.proxyUserName + ')') : ''}<DownOutlined />
              </Button>
            </Dropdown>
            <Button onClick={this.helpAi} type="link" style={{ color: '#FFF' }}>
              <QuestionCircleTwoTone />
              帮助
            </Button>
          </div>
        </div>

        {/* 切换用户弹出框 */}
        <Modal width="500px" title="切换用户" visible={this.state.changeUserModalVisible}
          onOk={this.changeProxyUser} onCancel={this.hideChangeUserModal}
          okText="确认" cancelText="取消" className='addModal'>
          <Row style={{ marginBottom: 5 }}>
            <Col span={6} style={{ textAlign: 'right', lineHeight: '30px' }}>
              当前代理用户：
            </Col>
            <Col span={18}>
              <Input disabled={true} value={SessionService.proxyUserName} />
            </Col>
          </Row>
          <Row gutter={[0, 16]}>
            <Col span={6} style={{ textAlign: 'right', lineHeight: '30px' }}>
              切换到：
            </Col>
            <Col span={18}>
              <Select showSearch style={{ width: '100%' }} placeholder="选择代理用户"
                allowClear={true}
                defaultActiveFirstOption={false} filterOption={false}
                notFoundContent={null}
                onSearch={this.changeUserInputChange}
                value={this.state.proxyUserId}
                onChange={this.changeUserSelectChange}>
                {
                  proxyUserList.map(userInfo =>
                    (<Option key={userInfo.userId}>{userInfo.userName}</Option>))
                }
              </Select>
            </Col>
          </Row>
        </Modal>

        {/* 修改密码弹出框 */}
        <Modal width="300px" title="修改密码" visible={this.state.changePasswordModalVisible}
          onOk={this.confirmChangePassword} onCancel={this.hideChangePasswordModal}
          okText="确认" cancelText="取消" className='addModal' maskClosable={false}>
          <Form {...layout} ref={this.passwordChangeFormRef}>
            <Form.Item
              label="旧密码"
              name="oldPassword"
              rules={[{ required: true, message: '请输入旧密码' }]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              label="新密码"
              name="newPassword"
              rules={[{ required: true, message: '请输入新密码' }]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              label="确认密码"
              name="confirmPassword"
              rules={[{ required: true, message: '请输入确认密码' }]}
            >
              <Input.Password />
            </Form.Item>
          </Form>
        </Modal>

        {/* 医院选择弹出框 */}
        <Modal width="300px" title="医院选择" visible={this.state.hospitalChangeModalVisible}
          footer={null} onCancel={this.hideHospitalChangeModal}
          className='addModal'>
          <Form {...layout}>
            <Form.Item
              label="医院"
              name="hospital"
            >
              <Select placeholder='请选择医院' onChange={value => {
                this.changeHospital(value);
                this.hideHospitalChangeModal();
              }}>
                {this.state.hospitalList.map(value =>
                  (<Select.Option key={value.key}
                  >{value.value}</Select.Option>)
                )}
              </Select>
            </Form.Item>
          </Form>
        </Modal>

        {/* 有效公告弹出框 */}
        <Modal
          title="公告信息"
          visible={noticeActiveModalVisible}
          onCancel={this.handleNoticeActiveModal}
          className='addModal'
          bodyStyle={{ backgroundColor: '#f0f0f0', paddingTop: '10px' }}
          width={800}
          maskClosable={false}
          footer={[
            <Button key="handle" type="primary" style={{ marginLeft: 20 }} onClick={() => this.handleNoticeClick(apiNoticeActiveList)}>去处理({apiNoticeActiveList.length})</Button>,
            <Button key="accept" type="primary" style={{ marginLeft: 20 }} onClick={() => this.handleNoticeActiveModal()}>知道了</Button>
          ]}
        >
          <Space direction="vertical" style={{ display: 'flex' }}>
            {
              noticeActiveList.map(notice => {
                return (
                  <div key={notice.id}>
                    <Card title={<b>{notice.noticeName}</b>} bordered={false} style={{ width: '100%' }}
                      extra={notice.noticeType === 1
                        ? <Button type="link" htmlType="button" onClick={(e) => { e.stopPropagation(); this.handleNoticeClick([notice]); }}>去处理</Button>
                        : <Checkbox key="reshowFlag" onChange={(event) => this.onCheckboxChange(notice.id, event.target.checked)}>下次不再显示</Checkbox>}>
                      <p>{notice.noticeContent}</p>
                      {notice.fileList && notice.fileList.length > 0
                        ? <Upload key="showFile" showUploadList={{ showRemoveIcon: false }} fileList={notice.fileList}/>
                        : null}
                    </Card>
                  </div>
                );
              })
            }
          </Space>
        </Modal>

        {/* 历史公告弹出框 */}
        <NoticeHistoryModal onRef={ref => (this.noticeHistoryRef = ref)} />
      </Header>
    );
  }
}

export default enhance(PageHeader);
